import isNil from 'lodash/isNil';
import React from 'react';
import { Link } from 'react-router-dom';

import routeFactory from '../../../../../../common/util/routeFactory';
import { DatalabScreens } from '../../../../../datalab/constants';
import type { Calendar_OfferingManagerPartsFragment } from '../../../../graphql/__generated__/Calendar_GridRowData';
import type { CalendarGridCustomCellRendererProps } from '../../CalendarGrid.model';

export type Value = Calendar_OfferingManagerPartsFragment;

export type LeftLeadCellRendererProps = CalendarGridCustomCellRendererProps<Value>;

export const LeftLeadCellRenderer: React.FC<LeftLeadCellRendererProps> = ({
  valueFormatted,
  value,
}) => {
  const url = routeFactory.datalab.getUrlPath({
    screen: DatalabScreens.UNDERWRITER_OFFERINGS,
    type: 'table',
    query: {
      underwriter: value?.managerId,
    },
  });

  if (isNil(value)) {
    return <React.Fragment>{valueFormatted}</React.Fragment>;
  }

  return <Link to={url}>{valueFormatted}</Link>;
};
